export default __webpack_public_path__ + "static/media/Asset 12.0b90df60.svg";